import { tryLoadDependencies, tryLoadLightDOMStyles, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader-Level2.styles'

const t = document.createElement('template')
t.innerHTML = `
  <!-- TODO: class needed for "menu-open" -->
  <header class="ascend-header ascend-header-level2 header-inner" role="banner">
    <!-- Top Header: -->
    <nav class="main-nav" role="navigation" aria-label="Main Navigation">
      <!-- logo -->
      <slot name="logo"></slot>
      <!-- Site action & profile menu -->
      <slot name="utilityNavigation"></slot>
    </nav>
    <div class="mobile-header">
      <slot name="primarySearchContainer"></slot>
      <slot name="mobilecontextualNavigation"></slot> 
    </div>

    <slot name="primaryNavigationMobile"></slot>
    <div class="tab-header">
      <slot name="contextualNavigation"></slot> 
    </div>
  </header>
`
const TemplateNavHeader = t

class NavHeaderLevel2 extends HTMLElement {
  private isOpen = false;
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Tree, WebAwesomeComponent.TreeItem])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavHeader.content.cloneNode(true))

    tryLoadLightDOMStyles('NavHeader-Level2.css')
  }

  connectedCallback() {
    console.log('NavigationSiteHeader connectedCallback')


    this.addEventListener('toggle-hamburger', () => {
      this.isOpen = !this.isOpen
      this.classList.toggle('mobile-nav-open', this.isOpen)
    })

    this.addEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.addEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
  }
  disconnectedCallback() {
    this.removeEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.removeEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
  }

  private handleSearchStateChange = (event: CustomEvent) => {
    const { visible } = event.detail
    const value = visible.toString()


    this.querySelectorAll('ts-navheader-search-container').forEach((el) =>
      el.setAttribute('search-visible', value),
    )


    this.querySelectorAll('ts-navheader-utility-buttongroup').forEach((el) =>
      el.setAttribute('search-visible', value),
    )

    this.querySelectorAll('ts-navheader-utility-search').forEach((el) =>
      el.setAttribute('search-visible', value),
    )
  }
  private handleSearchIconClick = (event: CustomEvent) => {
    console.log('Search icon clicked:', event.detail)
  }
}

if (!customElements.get('ts-navheader-level2')) {
  customElements.define('ts-navheader-level2', NavHeaderLevel2)
}

export { NavHeaderLevel2 }


